import React from 'react';

import {
  useTranslation,
} from 'react-i18next';

import {
  TranslateConfig,
} from '@noitada/shared/translations';

import {
  DetailsSectionView,
  SubtitleDetails,
  SubtitleText,
} from '../../../../../../styles/styled.layout';



export interface IProps {
  about?: string;
}



const DetailsAbout: React.FC<IProps> = (props: IProps) => {
  const { t: translate } = useTranslation();



  return (

    <DetailsSectionView>
      <SubtitleDetails>
        {translate(TranslateConfig.EVENT_ABOUT)}
      </SubtitleDetails>


      <SubtitleText>
        {props.about}
      </SubtitleText>
    </DetailsSectionView>

  );
};



export default DetailsAbout;
